import React, { useState, useEffect } from "react";

import { getOpenEvents, getReservationByPerson } from "services/event.service";
import { isAuth } from "services/auth.service";
import { useApp } from "context/appContext";

import GetReservation from "./layout";

function GetReservationContainer() {
  const [loading, setLoading] = useState(true);
  const [showQR, setShowQR] = useState(false);
  const [events, setEvents] = useState([]);
  const [code, setCode] = useState(null);

  const { showNotification } = useApp();

  const getReservationByCC = async (values) => {
    setLoading(true);
    try {
      const reservationInfo = await getReservationByPerson(values);
      setCode(reservationInfo.code);
      setShowQR(true);
    } catch (err) {
      console.log(err.message);
      showNotification(
        "No se ha encontrado tu reserva, por favor contacta con el administrador",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function getEvents() {
      try {
        const openEvents = await getOpenEvents();
        if (isAuth()) {
          setEvents(openEvents);
        } else {
          setEvents(openEvents.filter((event) => event.type !== "PRV"));
        }
      } catch (err) {
        console.log(err.message);
        showNotification(
          "Ha ocurrido un error al consultar la información de los servicios. Por favor contacta con el administrador",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }

    getEvents();
    // eslint-disable-next-line
  }, []);

  return (
    <GetReservation
      events={events}
      showQR={showQR}
      onGetReservation={getReservationByCC}
      loading={loading}
      code={code}
    />
  );
}

export default GetReservationContainer;
